<template>
  <v-container fluid style="padding: 0">
    <carousel-3d
      ref="mycarousel"
      width="500"
      height="400"
      border="7"
      :autoplay="false"
      :autoplayTimeout="5000"
      :autoplayHoverPause="true"
      @before-slide-change="onBeforeSlideChange"
      @last-slide="onLastSlide"
    >
      <slide v-for="(slide, i) in slides" :index="i" :key="'slide' + i">
        <div @click="goToDesc(i)">
          <img :src="`/static/storyboard/${i + 1}.jpg`" />
        </div>
        <div class="stage stage_top">Step {{ i + 1 }}</div>
      </slide>
    </carousel-3d>
    <v-container style="padding-top: 0">
      <div ref="timeline" class="timeline">
        <v-timeline>
          <v-timeline-item
            v-for="(slide, i) in slides"
            :key="'timeline' + i"
            large
          >
            <template v-slot:icon>
              <v-avatar width="100" height="100">
                <img
                  :src="`/static/storyboard/${i + 1}.jpg`"
                  @click="goToSlide(i)"
                />
              </v-avatar>
            </template>
            <template v-slot:opposite>
              <span :ref="'timeline' + i"></span>
            </template>
            <v-card class="elevation-2" @click="goToSlide(i)">
              <v-card-title class="text-h5 stage stage_title">
                {{ slide.name }}
              </v-card-title>
              <v-card-text class="desc">{{ slide.desc }}</v-card-text>
            </v-card>
          </v-timeline-item>
        </v-timeline>
      </div>
    </v-container>
  </v-container>
</template>

<script>
import { Carousel3d, Slide } from "vue-carousel-3d"; // https://wlada.github.io/vue-carousel-3d/guide/
export default {
  name: "landing2",
  components: {
    Carousel3d,
    Slide,
  },
  data: () => ({
    slides: [
      {
        name: "Step 1",
        desc: "Open 4ypx/silcs_fragmaps_4ypx/view_maps.vmd using VMD and un-display all FragMaps",
      },
      {
        name: "Step 2",
        desc: "Display “Generic Apolar Map” “Generic Donor Map” and “Generic Acceptor Map” ",
      },
      {
        name: "Step 3",
        desc: "Load 4ypx/4ypx.pdb and display the ligand “not (protein or water)” in licorice representation, bond radius 0.2",
      },
      {
        name: "Step 4",
        desc: "Zoom in to the ligand",
      },
      {
        name: "Step 5",
        desc: "Reorient the view",
      },
      {
        name: "Step 6",
        desc: "Hide the protein",
      },
      {
        name: "Step 7",
        desc: "Hide the Generic Apolar Map and the Generic Acceptor map, and add a VDW representation with sphere scale 0.5 for “not (protein or water) and name N”",
      },
      {
        name: "Step 8",
        desc: "Hide the Generic Donor Map and display the Generic Acceptor map, hide the VDW representation for not (protein or water) and name N” and add a VDW representation with sphere scale 0.5 for “not (protein or water) and (name O or name N2)”",
      },
      {
        name: "Step 9",
        desc: "Hide the Generic Acceptor Map and display the Generic Apolar map, hide the VDW representation for not (protein or water) and (name O or name N2)” and add a VDW representation with sphere scale 0.5 for “not (protein or water) and carbon” ",
      },
      {
        name: "Step 10",
        desc: "Hide the VDW representation for not (protein or water) and carbon” and load in 4ypx/4ypw.pdb",
      },
      {
        name: "Step 11",
        desc: "Add VDW representation 4ypx/4ypw.pdb ligand carbons",
      },
      {
        name: "Step 12",
        desc: "Rotate the view",
      },
      {
        name: "Step 13",
        desc: "Re-display the protein from Step 1",
      },
      {
        name: "Step 14",
        desc: "Zoom out… ",
      },
      {
        name: "Step 15",
        desc: "Zoom out more",
      },
    ],
  }),
  methods: {
    goToSlide(index) {
      console.log("goToSlide", index);
      this.$refs.mycarousel.goSlide(index);
    },
    goToDesc(index) {
      console.log(
        "goToDesc",
        index,
        this.$refs["timeline" + index],
        this.$refs["timeline" + index][0].offsetTop
      );
      this.$refs["timeline"].scrollTop =
        this.$refs["timeline" + index][0].offsetTop - 100;
      // this.$refs['timeline'+index].scrollIntoView({ behavior: 'smooth' });
    },
    onBeforeSlideChange(index) {
      this.goToDesc(index);
      console.log(
        "@onBeforeSlideChange Callback Triggered",
        "Slide Index " + index
      );
    },
    onLastSlide(index) {
      console.log("@onLastSlide Callback Triggered", "Slide Index " + index);
    },
  },
};
</script>

<style scoped>
.stage {
  background: rgb(49, 90, 151);
  color: white;
}
.stage_top {
  position: absolute;
  top: 0px;
  padding: 10px 30px;
  font-weight: bold;
}
.stage_title {
  font-weight: bold !important;
}
.carousel-3d-container {
  margin: 0 !important;
  padding: 30px 0 10px;
  height: 460px !important;
  background: #eaeff9;
}
.carousel-3d-slide {
  box-shadow: 0px 2px 4px -1px rgb(0 0 0 / 20%),
    0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%);
  border-radius: 30px;
  border: 10px solid #aac2d6;
}
.carousel-3d-slide img {
  width: 500px;
  height: 400px;
}
.timeline {
  max-height: 400px;
  overflow-y: auto;
}

.v-timeline-item__dot,
.v-timeline-item__dot,
.v-timeline-item__inner-dot,
.v-timeline-item__dot--large .v-timeline-item__inner-dot .v-avatar {
  min-width: 100px !important;
  width: 100px !important;
  height: 100px !important;
}
.v-timeline-item__inner-dot {
  width: 100px !important;
  height: 100px !important;
}
.desc {
  font-size: 16px;
  min-height: 100px;
  padding-top: 20px !important;
  color: #05192c !important;
}
.v-avatar {
  border: 4px solid #c9dbe9;
}
</style>